<div class="usz-wrap">
  <section class="usz-kartya">
    <!-- Fejléc -->
    <header class="usz-fej">
      <div class="usz-fej-ikon"><ion-icon name="pulse-outline"></ion-icon></div>
      <div class="usz-fej-szoveg">
        <h1>Üzemszünet-figyelő</h1>
        <p>A külső rendszerek (NAV, Ügyfélkapu, bank, e-Önkormányzat) elérhetősége</p>
      </div>
      <button type="button" class="usz-frissit" (click)="betolt()" [disabled]="loading" title="Állapot frissítése">
        <ion-icon name="refresh-outline" [class.forog]="loading"></ion-icon>
      </button>
    </header>

    <ion-progress-bar type="indeterminate" *ngIf="loading"></ion-progress-bar>

    <!-- Összegző sor -->
    <div class="usz-osszegzo" [class.aktiv]="vanAktiv">
      <ion-icon [name]="vanAktiv ? 'alert-circle-outline' : 'checkmark-circle-outline'"></ion-icon>
      <span>{{ vanAktiv ? 'Van aktív üzemszünet vagy tervezett karbantartás.' : 'Minden figyelt rendszer rendben.' }}</span>
    </div>

    <!-- Források -->
    <ul class="usz-lista">
      <li *ngFor="let f of forrasok" class="usz-elem"
          [class.tervezett]="f.allapot === 'tervezett'"
          [class.kieses]="f.allapot === 'kieses'">
        <div class="usz-sor">
          <span class="usz-pont" [attr.data-allapot]="f.allapot"></span>
          <div class="usz-nev-blokk">
            <span class="usz-nev">{{ f.nev }}</span>
            <span class="usz-uzenet" *ngIf="f.uzenet">{{ f.uzenet }}</span>
            <span class="usz-ido" *ngIf="idoablakSzoveg(f.idoablak_kezd, f.idoablak_veg) as ido">
              <ion-icon name="calendar-outline"></ion-icon><b *ngIf="kozelgo(f)">Tervezett karbantartás – </b>{{ ido }}
            </span>
          </div>
          <span class="usz-badgek">
            <ion-badge color="warning" *ngIf="kozelgo(f)">Közelgő</ion-badge>
            <ion-badge [color]="allapotSzin(f.allapot)">{{ allapotCim(f.allapot) }}</ion-badge>
          </span>
        </div>

        <div class="usz-meta">
          <span class="usz-meta-elem">
            <ion-icon [name]="forrasTipusIkon(f.forras_tipus)"></ion-icon>
            {{ forrasTipusCim(f.forras_tipus) }}
          </span>
          <span class="usz-meta-elem" *ngIf="f.frissitve">
            <ion-icon name="time-outline"></ion-icon>
            Frissítve: {{ datumSzoveg(f.frissitve) || f.frissitve }}
          </span>
          <button type="button" class="usz-kezi-gomb" (click)="panelValt(f)">
            <ion-icon [name]="szerk[f.forras]?.nyitva ? 'chevron-up-outline' : 'create-outline'"></ion-icon>
            {{ szerk[f.forras]?.nyitva ? 'Bezár' : 'Kézi felülírás' }}
          </button>
        </div>

        <!-- Kézi felülírás (admin) -->
        <div class="usz-szerk" *ngIf="szerk[f.forras]?.nyitva">
          <ion-item>
            <ion-label position="stacked">Állapot</ion-label>
            <ion-select [(ngModel)]="szerk[f.forras].allapot" interface="popover">
              <ion-select-option *ngFor="let o of allapotOpciok" [value]="o.ertek">{{ o.cim }}</ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item>
            <ion-label position="stacked">Üzenet (a felhasználóknak)</ion-label>
            <ion-textarea [(ngModel)]="szerk[f.forras].uzenet" auto-grow="true" rows="2"
                          placeholder="Pl. A NAV rendszere karbantartás miatt nem elérhető."></ion-textarea>
          </ion-item>

          <div class="usz-ido-sor">
            <ion-item>
              <ion-label position="stacked">Időablak – kezdete</ion-label>
              <ion-input type="datetime-local" [(ngModel)]="szerk[f.forras].idoablak_kezd"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label position="stacked">Időablak – vége</ion-label>
              <ion-input type="datetime-local" [(ngModel)]="szerk[f.forras].idoablak_veg"></ion-input>
            </ion-item>
          </div>

          <div class="usz-gombsor">
            <ion-button color="success" size="small" (click)="ment(f)" [disabled]="foglalt[f.forras]">
              <ion-icon slot="start" name="save-outline"></ion-icon> Mentés
            </ion-button>
            <ion-button fill="outline" color="medium" size="small" (click)="torol(f)" [disabled]="foglalt[f.forras]">
              <ion-icon slot="start" name="trash-outline"></ion-icon> Kézi törlése
            </ion-button>
          </div>
          <ion-note color="medium" class="usz-jog-note">
            A kézi felülírás adminisztrátori jog – ha nincs jogosultságod, a mentés hibát jelez.
          </ion-note>
        </div>
      </li>
    </ul>

    <div class="usz-ures" *ngIf="!loading && !forrasok.length">
      <ion-icon name="cloud-offline-outline"></ion-icon>
      <p>Nincs megjeleníthető forrásállapot.</p>
    </div>
  </section>
</div>
